import script from "./SongViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./SongViewer.vue?vue&type=script&setup=true&lang=js"

import "./SongViewer.vue?vue&type=style&index=0&id=108b9a61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108b9a61"]])

export default __exports__